import {
    Button, Modal, App
  } from 'antd';
 import {
    WarningOutlined,  
  } from '@ant-design/icons';
import React, { useState, useEffect, useCallback } from "react";  
import { useTranslation } from "react-i18next";
import VehicleTyreDiagram from '../../components/image/VehicleTyreDiagram';
import './RecordTyreRequest.css';
import TyreRequestDetails from '../tyre_request/TyreRequestDetails';
import { getVehicleTyresSvg } from "../../api/vehicle";
import useWindowSize from "../../utility/hooks/useWindowSize";


const RecordTyreRequest = ({isModalVisible, setIsModalVisible, loadingProgress, setLoadingProgress, submitProgress, setSubmitProgress, vehicle, driver, currentTyreRequest, setCurrentTyreRequest}) => {
    const { t } = useTranslation();
    const { notification } = App.useApp();
    const [tyreRequestDetailsModalVisible, setTyreRequestDetailsModalVisible] = useState(false);
    const [windowWidth] = useWindowSize();
    const popupCentre = (windowWidth  / 2);
    const [diagramHeight, setDiagramHeight] = useState(60);
    const [positionsLoaded, setPositionsLoaded] = useState(false);
    const tempAxleDetails = {
        axles: [{
          axle: {
            axleNumber: 1,
          },
          leftTyres: [{axlePositionCode: 'L1', id:1}],
          rightTyres: [{axlePositionCode: 'R1', id:2}],
        }, {
          axle: {
            axleNumber: 2,
          },
          leftTyres: [{axlePositionCode: 'L1', id:3}],
          rightTyres: [{axlePositionCode: 'R1', id:4}],
        }],      
        spareTyres: [{axlePositionCode: 'S1', id:5}],
      }; 
    const [axleDetails, setAxleDetails] = useState(tempAxleDetails);      

    const updateTyrePositions = useCallback((vehicleAxleDetails) => {
        vehicleAxleDetails.baseAxleHeight = -120;

        for (let i = 0; i < vehicleAxleDetails.axles.length; i++)
        {
            const leftPos =  popupCentre - 50;
            const topPos =  220 + (i * 120); 
            
            vehicleAxleDetails.axles[i].leftPos = leftPos + 'px';
            vehicleAxleDetails.axles[i].topPos = topPos + 'px';
            vehicleAxleDetails.baseAxleHeight = vehicleAxleDetails.baseAxleHeight + 120;

            for (let k  = 0; k < vehicleAxleDetails.axles[i].rightTyres.length; k++)
            {
                // totalTyreCount++
                const tyre = vehicleAxleDetails.axles[i].rightTyres[k];
                
                // Show the tyre at the same position as the axle less 40 (half width of tyre) to centre the tyre
                tyre.leftPos = (leftPos + 100) + (20 * k) + (9 * k) + 'px';

                // Calculate the position based on the width of the tyre (20), add a gap of 7 
                // 150 = top position of the axle-base + height of the axle-base
                tyre.topPos = (topPos - 40)  + 'px'; 
                
                // Set axle number whilst we are here for use in the summary screen
                tyre.axleNumber = vehicleAxleDetails.axles[i].axle.axleNumber;
            } 

            for (let k  = 0; k < vehicleAxleDetails.axles[i].leftTyres.length; k++)
            {
                const tyre = vehicleAxleDetails.axles[i].leftTyres[k];
                
                // Show the tyre at the same position as the axle less 40 (half width of tyre) to centre the tyre
                tyre.leftPos = (leftPos - 26) - (20 * k) - (9 * k) + 'px';

                // Calculate the position based on the width of the tyre (20), add a gap of 7 
                // 150 = top position of the axle-base
                tyre.topPos = (topPos - 40) + 'px'; 

                // Set axle number whilst we are here for use in the summary screen
                tyre.axleNumber = vehicleAxleDetails.axles[i].axle.axleNumber;
            }            
        }

        for (let i = 0; i < vehicleAxleDetails.spareTyres.length; i++)
        {
            const tyre = vehicleAxleDetails.spareTyres[i];
            // Place each spare tyre further right, add a gap of 7
            tyre.leftPos = (popupCentre - 40) + 'px'; 
            tyre.topPos = 220 + vehicleAxleDetails.baseAxleHeight + 60 + (20 * i) + (9 * i) + 'px'; 
        }
        setDiagramHeight(vehicleAxleDetails.baseAxleHeight + 150 + (vehicleAxleDetails.spareTyres.length * 27));        
        setPositionsLoaded(true);
    }, [popupCentre]);

    useEffect(() => {
        if (vehicle?.vehicleId)
        {
            getVehicleTyresSvg(vehicle?.vehicleId, setLoadingProgress)
            .then(vehicleAxleDetails => {
                if (vehicleAxleDetails && vehicleAxleDetails.axles.length > 0) {
                    updateTyrePositions(vehicleAxleDetails);
                }
                setAxleDetails(vehicleAxleDetails);
            }, err => {
            console.log(err);
            });
        }
    }, [vehicle?.vehicleId, setLoadingProgress, updateTyrePositions]);

    const vehicleHasAxles = (axleDetails && axleDetails?.axles && axleDetails?.axles?.length > 0);
    const axlesHasTyres = vehicleHasAxles && (axleDetails?.axles[0].leftTyres.length > 0 || axleDetails?.axles[0].rightTyres.length > 0 );
    const vehicleHasTyres = axlesHasTyres;

    const handleNavigationToTyreDetailsPage = () => {
        notification.destroy();

        let hasTyreRepairRequests = currentTyreRequest?.tyres?.length > 0;
        if (!hasTyreRepairRequests){
            notification.open({
                icon: <WarningOutlined style={{color: 'var(--dp-status-colour-warning)'}}/>,
                description: t('message.missing_tyre_repairs'),
                duration: null,
                });        
        }
        else {
            setIsModalVisible(false); 
            setTyreRequestDetailsModalVisible(true);
        }
    }


    return (
        <div>
            <Modal className="std-portal-popup std-portal-popup-adj"
                   open={isModalVisible}
                   title={t('title.tyre_request')}
                   closable={true}
                   maskClosable={false}
                    onCancel={() => {
                        setIsModalVisible(false); 
                        notification.destroy();
                        setCurrentTyreRequest({});
                    }}
                    afterClose={ () => {
                    }}
                    keyboard={false}
                    footer={
                        [
                            <Button key="cancel" 
                                    onClick={(e) => {
                                        setIsModalVisible(false); 
                                        notification.destroy();
                                        setCurrentTyreRequest({});
                                    }}
                            >
                            {t('action.cancel')}
                            </Button>,
                            !vehicleHasTyres
                            ?
                            <></>
                            :
                            <Button type="primary" 
                                    loading={loadingProgress < 100}
                                    onClick={() => {
                                        handleNavigationToTyreDetailsPage();
                                        
                                    }}
                            >
                            {t('action.next')}
                            </Button>,
                        ]
                    }
            >
                <VehicleTyreDiagram vehicle={vehicle}
                                    vehicleId={vehicle?.vehicleId}
                                    currentTyreRequest={currentTyreRequest}
                                    notification={notification}
                                    axleDetails={axleDetails}
                                    setAxleDetails={setAxleDetails}
                                    popupCentre={popupCentre}
                                    diagramHeight={diagramHeight}
                                    positionsLoaded={positionsLoaded}
                                    windowWidth={windowWidth}
                                    vehicleHasTyres={vehicleHasTyres}
                >
                </VehicleTyreDiagram>
            </Modal>  
            <TyreRequestDetails vehicle={vehicle}
                                driver={driver}
                                tyreRequestDetailsModalVisible={tyreRequestDetailsModalVisible}
                                setTyreRequestDetailsModalVisible={setTyreRequestDetailsModalVisible}
                                currentTyreRequest={currentTyreRequest}
                                setIsModalVisible={setIsModalVisible}
                                submitProgress={submitProgress}
                                setSubmitProgress={setSubmitProgress}
                                setCurrentTyreRequest={setCurrentTyreRequest}
            >
            </TyreRequestDetails>        
        </div>
     );    
}

export default RecordTyreRequest;